module.exports = __webpack_public_path__ + "ras_icon.svg?0908e16c1f66065a6c58dafb2e18e4cc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/ras_icon.svg
// module id = 1131
// module chunks = 2